exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".smallDisplay .container{max-width:100vw!important}.v-dialog:not(.v-dialog--fullscreen){max-height:90%}", ""]);

// exports
